import { axiosGet, axiosPost } from "../../../react_axios/Axios"
import {
    headers, getExhibitorItineraryListUrl, insertUpdateExhibitorItineraryUrl, deleteExhibitorItineraryUrl, GET_EXH_ITINERARY_LIST, INSERT_UPDATE_EXH_ITINERARY, DELETE_EXH_ITINERARY
} from "../../../utils/constants"

export const getExhibitorItineraryList_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExhRegistrationID: sessionStorage.getItem("ExhRegistrationIDSS"),
        }

        const res = await axiosGet(getExhibitorItineraryListUrl, params, headers)

        dispatch({
            type: GET_EXH_ITINERARY_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateExhibitorItinerary_action = (ExhibitorItineraryList, ExhibitorItineraryID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExhRegistrationID: sessionStorage.getItem("ExhRegistrationIDSS"),
            ExhibitorItineraryList: ExhibitorItineraryList,
            ExhibitorItineraryID: ExhibitorItineraryID,
        }

        const res = await axiosPost(insertUpdateExhibitorItineraryUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_EXH_ITINERARY,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteExhibitorItinerary_action = (ExhibitorItineraryID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExhibitorItineraryID: ExhibitorItineraryID
        }

        const res = await axiosGet(deleteExhibitorItineraryUrl, params, headers)

        dispatch({
            type: DELETE_EXH_ITINERARY,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}